export default __webpack_public_path__ + "media/images/react_icons/question-circle-4a894d2b2cf8ac96c24d29769d328eff.svg";